module.exports = __webpack_public_path__ + "media/images/photo/plans/common/img_memory-photo-79874549501ac8d86ff70084a76f3296.jpg";